import setupSlider from './slider';
import setupPlayer from './player';

export default function setupHeroSlider(classNames) {
  if (!classNames.slider || !classNames.video) return;

  const videos = document.querySelectorAll(classNames.video);
  if (videos && videos.length) {
    const arr = [];
    [...videos].forEach((video) => {
      arr.push(setupPlayer(video.getAttribute('id')));
    });
    setupSlider(classNames.slider, arr);
  } else {
    setupSlider(classNames.slider);
  }
}
